import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import { Link } from "react-router-dom";

const PuneLinks = () => {
  return (
    <>
      <Swiper
        className="region-button"
        spaceBetween={10} // Space between slides
        breakpoints={{
          425: {
            slidesPerView: 2, // Show 2 slides on small screens
            spaceBetween: 10,
          },
          768: {
            slidesPerView: 4, // Show 4 slides on tablets
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 4, // Show based on content on larger screens
            spaceBetween: 10,
          },
        }}
        freeMode={true} // Enable free scrolling
        style={{
          padding: "10px 0px", // Padding around text
        }}
      >
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              {/* <p className="footer-link-mainheading">Western Suburbs</p> */}
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to={
                      "https://homesdekho.com/pune/propertiesbyregion/Chinchwad"
                    }
                  >
                    Property in Chinchwad
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to={"https://homesdekho.com/pune/propertiesbyregion/Baner"}
                  >
                    Property in Baner
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to={
                      "https://homesdekho.com/pune/propertiesbyregion/Talegaon-Dabhade"
                    }
                  >
                    Property in Talegaon Dabhade
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Moshi"
                  >
                    Property in Moshi
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Charholi-Budruk"
                  >
                    Property in Charholi Budruk
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Chikhali"
                  >
                    Property in Chikhali
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Shivaji-Nagar"
                  >
                    Property in Shivaji Nagar
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="property-review-slider">
          <div>
            <div>
              <ul className="footer-link-ul">
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Kharadi"
                  >
                    Property in Kharadi
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Hinjawadi"
                  >
                    Property in Hinjawadi
                  </Link>
                </li>
                <li>
                  <Link
                    target="_blank"
                    to="https://homesdekho.com/pune/propertiesbyregion/Wakad"
                  >
                    Property in Wakad
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </SwiperSlide>
      </Swiper>
    </>
  );
};

export default PuneLinks;
